import styled from 'styled-components';

export default styled.td`
  opacity: 1;
  color: #c5cede;
  overflow: hidden;
  vertical-align: top;
`;
